import { CompanyClientDataType } from '@upright/common/model/company-client-data/types';
import {
  deleteCompanyClientDataReaction,
  deleteCompanyClientDataRequest,
  postCompanyClientDataReaction,
  postCompanyClientDataRequest,
} from '@upright/ui/api/model/company-client-data/reactions';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getCompanyClientDataSetOptions } from './use-get-company-client-dataset';

const MUTATION_ID_DELETE_REQUEST = 'company-client-data-delete-request';
const MUTATION_ID_POST_REQUEST = 'company-client-data-post-request';
const MUTATION_ID_POST_REACTION = 'company-client-data-post-reaction';
const MUTATION_ID_DELETE_REACTION = 'company-client-data-delete-reaction';

export function usePostCompanyClientDataReaction(companyId: string, type: CompanyClientDataType, id: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [MUTATION_ID_POST_REACTION, companyId, type, id],
    mutationFn: async () => {
      await postCompanyClientDataReaction(companyId, type, id);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries(
        getCompanyClientDataSetOptions({
          companyId,
          type,
          isDraft: false,
        }),
      );
    },
  });
}

export function useDeleteCompanyClientDataReaction(companyId: string, type: CompanyClientDataType, id: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [MUTATION_ID_DELETE_REACTION, companyId, type, id],
    mutationFn: async () => {
      await deleteCompanyClientDataReaction(companyId, type, id);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries(
        getCompanyClientDataSetOptions({
          companyId,
          type,
          isDraft: false,
        }),
      );
    },
  });
}

export function usePostCompanyClientDataRequest(companyId: string) {
  return useMutation({
    mutationKey: [MUTATION_ID_POST_REQUEST, companyId],
    mutationFn: async () => {
      return await postCompanyClientDataRequest(companyId);
    },
  });
}

export function useDeleteCompanyClientDataRequest(companyId: string) {
  return useMutation({
    mutationKey: [MUTATION_ID_DELETE_REQUEST, companyId],
    mutationFn: async () => {
      return await deleteCompanyClientDataRequest(companyId);
    },
  });
}
